import React, {Component,useState,useEffect} from 'react';
import {PieChart, Pie, Cell, Legend, Tooltip} from 'recharts';
import {get,orderBy} from 'lodash-es'
import styled from 'styled-components'
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

const LegendList = styled.ul`
  list-style-type: none;
  padding: 10px;
  border-radius: 5px;
  background: rgba(0,0,0,.01);
  overflow-y: auto;
  max-height: 400px;
  margin-right: 50px;
  margin-top: 50px;
`
const LegendItem = styled.li`
  padding: 1px;
  ${props => props.active && "background: rgba(0,0,0,.05);" }
`

const LegendSvg = ({cor}) => (
  <svg width="14" height="14" viewBox="0 0 32 32" version="1.1" style={{display: "inline-block", verticalAlign: "middle", marginRight: "4px"}}>
    <path stroke="none" fill={cor} d="M0,4h32v24h-32z">
    </path>
  </svg>
)

class LegendCustom extends Component {
  onMouseEnter = o => this.props.onMouseEnter(o)
  onMouseLeave = o => this.props.onMouseLeave(o)
  render() {
    const { payload, selected, onMouseEnter, onMouseLeave} = this.props;
    return (
      <LegendList>
      {payload.map((el, i) => (
        <LegendItem key={`item-${i}`}
          active={selected && (el.payload.Id === selected.Id)}
          onMouseEnter={()=>onMouseEnter(el)}
          onMouseLeave={()=>onMouseLeave(el)}
        >
          <LegendSvg cor={el.color} />
          {el.value}
        </LegendItem>
      ))}
      </LegendList>
    );
  }
}

const Box = styled(Paper)`
  box-sizing: border-box;
  padding: 10px;
  width: 320px;
  p { color: ${props=>props.cor}; }
`

class TooltipCustom extends Component {
  componentWillUpdate(nextProps) {
    const { payload, active } = nextProps;
    const { props } = this
    const el = active && payload && payload[0] || false
    const oldEl = props.active && props.payload && props.payload[0] || false
    const Id = get(el, "payload.Id")
    const oldId = get(oldEl, "payload.Id")
    if (active && (Id !== oldId)) {
      this.props.enter(el)
    }
    if (!active && props.active) {
      this.props.leave()
    }
  }
  render() {
    const { selected } = this.props;
    if (!selected) return null;
    // let { fill, name, value } = selected
    let { fill, name, value, pct, Legenda } = selected
    return (
      <Box cor={fill}>
        <Typography variant="body1" gutterBottom align="center">
          {Legenda}
        </Typography>
        <Typography variant="body1" gutterBottom align="center">
          {name}
        </Typography>
        <Typography variant="body1" gutterBottom align="center">
          {value} ({pct} %)
          {/* {value} */}
        </Typography>
      </Box>
    )
  }
}


class ChartPie extends Component {
	state = { selected: null };
  handleMouseEnter = o => {
    const { dataKey, modif=a=>a } = this.props
    let { fill, Nome :name, Id, pct, Legenda } = o.payload
    let value = get(o, `payload.${dataKey}`)
    value = modif(value)
    // let pct = get(o, `payload.${dataKey}%`)
    // pct = `${parseFloat(pct).toFixed(2)}%`
  	// this.setState({ selected: { Id, name, value, fill } });
  	this.setState({ selected: { Id, name, value, fill, pct, Legenda } });
  }
  handleMouseLeave = o => this.setState({ selected: null });
  render() {
    let { data, dataKey, legendKey, total, modif } = this.props
    data = data.filter(d => d[dataKey] > 0)
    data = data.map(d => ({
      ...d,
      Legenda: `${d.Id} - ${d[legendKey]}`,
      pct: parseFloat(d[dataKey] / total * 100).toFixed(2)
    }))
    data = orderBy(data, dataKey, "desc")
    const { selected } = this.state
    const { Id } = (selected || {})
    return (
      <PieChart width={800} height={500}>
        <Pie
          data={data} nameKey="Legenda" dataKey={dataKey}
          cx={200} cy={200}
          innerRadius={80} outerRadius={160}
          fill="#82ca9d"
          animationDuration={800}
        >
        {data.map(cat => (
          <Cell
            fill={cat.Cor}
            fillOpacity={selected && (cat.Id !== Id) && .5 || 1}
          />
        ))}
        </Pie>
        <Tooltip
          content={(
            <TooltipCustom
              selected={selected}
              dataKey={dataKey}
              enter={this.handleMouseEnter}
              leave={this.handleMouseLeave}
            />)}
          defaultShowTooltip
          active
          position={{x:50,y:380}}
          wrapperStyle={{visibility:"visible"}}
        />
        <Legend
          content={<LegendCustom selected={selected} />}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          layout="vertical"
          align="right"
          verticalAlign="top"
        />
      </PieChart>
    );
  }

}


export default ChartPie
